import { redirect } from 'react-router-dom'

import { getAuth, onAuthStateChanged, type User } from 'firebase/auth'

import { firebaseApp } from './firebase'

/**
 * Wait for Firebase to restore the auth state on initial load.
 * Without this, currentUser is null on first navigation even if a session exists.
 */
export function waitForAuthReady(): Promise<User | null> {
	return new Promise((resolve) => {
		const auth = getAuth(firebaseApp)
		const unsubscribe = onAuthStateChanged(auth, (user) => {
			unsubscribe()
			resolve(user)
		})
	})
}

/**
 * Use as a route loader (or inside one) to gate authenticated pages.
 * Redirects to /login when no user is signed in.
 */
export async function requireUser() {
	const user = await waitForAuthReady()
	if (!user) {
		throw redirect('/login')
	}
	return user
}

/**
 * Use as a loader on /login and /signup to bounce already-authenticated users
 * straight to the dashboard instead of showing the auth forms.
 */
export async function redirectIfAuthenticated() {
	const user = await waitForAuthReady()
	if (user) {
		throw redirect('/')
	}
	return null
}
